<script>
    import { randString } from "../../scripts/functions";
    import { getEventsAction } from "../../scripts/utils.js";
    import { current_component, each } from "svelte/internal";
    import Button from "../Button/Button.svelte";
    import arrow from "../../../public/src/svg/section-title-after.svelte";
    import TextArrow from "../TextArrow/TextArrow.svelte"
    const events = getEventsAction(current_component);

    export let disabled = false;
    export let block = {};
    let localClass;
    while (true) {
        let tempClass = "carousel-block-" + randString(5);
        if (document.getElementsByClassName(tempClass).length === 0) {
            localClass = tempClass;
            break;
        }
    }


    function openLink(link) {
        console.log(link);
    }
</script>

<div
    class="{localClass} {$$props.class ? $$props.class : ''}"
    class:disabled
    use:events
>
    <img src={block.image} class="carousel-image" alt="" draggable="false" />
    <TextArrow class="carousel-text" text={block.text}/>
    <!-- <Button
        on:click={() => {
            openLink(block.link);
        }}
        size="42"
        class="carousel-button"
    >
        {block.button}
    </Button> -->
    <!-- <div class="carousel-button"></div> -->
</div>

<style lang="less" global>
    @import "CarouselBlock.less";
</style>
